var exports = {
  "kL": "x804f0401--b7f326--container",
  "wx": "x804f0401--b7f326--header",
  "fi": "x804f0401--b7f326--column",
  "nu": "x804f0401--b7f326--fixed-footer",
  "Km": "x804f0401--b7f326--more-reviews",
  "qN": "x804f0401--b7f326--ratings-filter",
  "_A": "x804f0401--b7f326--tags",
};

module.exports = exports;
